// Portfolio data - your positions (Updated March 2026)
// NOTE: This is FALLBACK data only. Real data comes from MongoDB via /api/portfolio/{owner}
export const PORTFOLIO = [
  // === HELMI - Millennium ===
  {id:"1", name:"Nvidia",            ticker:"NVDA",    qty:463,    avg:180.94,  broker:"Millennium",    owner:"Helmi",      sector:"IA / Tech",        flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"2", name:"Hensoldt",          ticker:"HAG.DE",  qty:767,    avg:84.72,   broker:"Millennium",    owner:"Helmi",      sector:"D\u00e9fense",     flag:"\u{1F1E9}\u{1F1EA}", strategy:"LT"},
  {id:"4", name:"Micron Technology", ticker:"MU",      qty:39,     avg:162.70,  broker:"Millennium",    owner:"Helmi",      sector:"Semi-conducteurs", flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  // === HELMI - Trading 212 ===
  {id:"28",name:"Oklo",              ticker:"OKLO",    qty:102.37, avg:93.76,   broker:"Trading 212",   owner:"Helmi",      sector:"Nucl\u00e9aire",   flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"15",name:"Greenidge",         ticker:"GREE",    qty:11837,  avg:2.12,    broker:"Trading 212",   owner:"Helmi",      sector:"Crypto Mining",    flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"16",name:"Hims & Hers",       ticker:"HIMS",    qty:219.77, avg:55.19,   broker:"Trading 212",   owner:"Helmi",      sector:"Sant\u00e9",       flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"17",name:"Autonomix",         ticker:"AMIX",    qty:10730,  avg:1.269,   broker:"Trading 212",   owner:"Helmi",      sector:"MedTech",          flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"19",name:"Direct Digital",    ticker:"DRCT",    qty:1485.55,avg:9.729,   broker:"Trading 212",   owner:"Helmi",      sector:"AdTech",           flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  // === HELMI - N26 ===
  {id:"29",name:"Broadcom",          ticker:"AVGO",    qty:30.96,  avg:335.67,  broker:"N26",           owner:"Helmi",      sector:"Semi-conducteurs", flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"30",name:"ARM Holdings",      ticker:"ARM",     qty:50,     avg:139.38,  broker:"Millennium",    owner:"Helmi",      sector:"Semiconductors",   flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  // === HELMI - Crypto ===
  {id:"31",name:"Bitcoin",           ticker:"BTC",     qty:0.30,   avg:74000,   broker:"N26",           owner:"Helmi",      sector:"Crypto",           flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"32",name:"Ethereum",          ticker:"ETH",     qty:4.2,    avg:3200,    broker:"N26",           owner:"Helmi",      sector:"Crypto",           flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"33",name:"VK Company",        ticker:"VK.PA",   qty:200,    avg:26.874,  broker:"Trading 212",   owner:"Helmi",      sector:"Tech",             flag:"\u{1F1F7}\u{1F1FA}", strategy:"ST"},
  // === ANNE-LAURE - Soc. G\u00e9n\u00e9rale ===
  {id:"7", name:"STMicro",           ticker:"STMPA.PA",qty:200,    avg:26.257,  broker:"Soc. G\u00e9n\u00e9rale", owner:"Anne-Laure", sector:"Semi-conducteurs", flag:"\u{1F1EB}\u{1F1F7}", strategy:"LT"},
  {id:"8", name:"Salesforce",        ticker:"CRM",     qty:45,     avg:231.74,  broker:"Soc. G\u00e9n\u00e9rale", owner:"Anne-Laure", sector:"SaaS",             flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"9", name:"Super Micro",       ticker:"SMCI",    qty:150,    avg:48.41,   broker:"Soc. G\u00e9n\u00e9rale", owner:"Anne-Laure", sector:"Hardware",         flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"10",name:"Duolingo",          ticker:"DUOL",    qty:20,     avg:299.848, broker:"Soc. G\u00e9n\u00e9rale", owner:"Anne-Laure", sector:"EdTech",           flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
  {id:"11",name:"MicroStrategy",     ticker:"MSTR",    qty:15,     avg:373.22,  broker:"Soc. G\u00e9n\u00e9rale", owner:"Anne-Laure", sector:"Bitcoin",          flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  // === ANNE-LAURE - Trading 212 ===
  {id:"20",name:"WT Uranium Nuclear", ticker:"NCLP.L", qty:263.53, avg:51.19,   broker:"Trading 212",   owner:"Anne-Laure", sector:"ETF Uranium",      flag:"\u{1F1EC}\u{1F1E7}", strategy:"LT"},
  {id:"22",name:"WT Strategic Metals",ticker:"WREE.L", qty:277.63, avg:46.94,   broker:"Trading 212",   owner:"Anne-Laure", sector:"ETF M\u00e9taux",  flag:"\u{1F1EC}\u{1F1E7}", strategy:"LT"},
  {id:"23",name:"iShares Gold",      ticker:"EGLN.L",  qty:220.26, avg:85.82,   broker:"Trading 212",   owner:"Anne-Laure", sector:"Or",               flag:"\u{1F1EC}\u{1F1E7}", strategy:"LT"},
  {id:"24",name:"SoFi Technologies", ticker:"SOFI",    qty:263,    avg:16.874,  broker:"Trading 212",   owner:"Anne-Laure", sector:"FinTech",          flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"26",name:"Innodata",          ticker:"INOD",    qty:78,     avg:54.67,   broker:"Trading 212",   owner:"Anne-Laure", sector:"IA Data",          flag:"\u{1F1FA}\u{1F1F8}", strategy:"ST"},
  {id:"34",name:"ARM Holdings",      ticker:"ARM",     qty:50,     avg:139.38,  broker:"Millennium",    owner:"Anne-Laure", sector:"Semiconductors",   flag:"\u{1F1FA}\u{1F1F8}", strategy:"LT"},
];

// Fixed prices for EU/UK tickers not supported by free Finnhub
export const EU_PRICES = {
  "HAG.DE":   77.65,
  "STMPA.PA": 28.18,
  "NCLP.L":   51.46,
  "WREN.L":   22.56,
  "WREE.L":   48.13,
  "EGLN.L":   42.90,
};

// MARKET SCANNER - Full market scan tickers by sector & region (Global coverage)
export const MARKET_SCAN_TICKERS = {
  // === MEGA CAP (Global) ===
  "MEGA_CAP": [
    { ticker: "AAPL", name: "Apple", sector: "Tech", flag: "🇺🇸" },
    { ticker: "MSFT", name: "Microsoft", sector: "Tech", flag: "🇺🇸" },
    { ticker: "GOOGL", name: "Alphabet", sector: "Tech", flag: "🇺🇸" },
    { ticker: "AMZN", name: "Amazon", sector: "E-commerce", flag: "🇺🇸" },
    { ticker: "META", name: "Meta", sector: "Social", flag: "🇺🇸" },
    { ticker: "TSLA", name: "Tesla", sector: "EV", flag: "🇺🇸" },
    { ticker: "BRK.B", name: "Berkshire", sector: "Conglomérat", flag: "🇺🇸" },
    { ticker: "JPM", name: "JPMorgan", sector: "Banque", flag: "🇺🇸" },
    { ticker: "BABA", name: "Alibaba", sector: "E-commerce", flag: "🇨🇳" },
    { ticker: "TCEHY", name: "Tencent", sector: "Tech", flag: "🇨🇳" },
    { ticker: "005930.KS", name: "Samsung", sector: "Tech", flag: "🇰🇷" },
    { ticker: "TM", name: "Toyota", sector: "Auto", flag: "🇯🇵" },
    { ticker: "MC.PA", name: "LVMH", sector: "Luxe", flag: "🇫🇷" },
    { ticker: "NESN.SW", name: "Nestlé", sector: "Conso", flag: "🇨🇭" },
  ],
  // === MID CAP (Global $2B-$20B) ===
  "MID_CAP": [
    { ticker: "SNAP", name: "Snap Inc", sector: "Social", flag: "🇺🇸" },
    { ticker: "RBLX", name: "Roblox", sector: "Gaming", flag: "🇺🇸" },
    { ticker: "HOOD", name: "Robinhood", sector: "Fintech", flag: "🇺🇸" },
    { ticker: "DKNG", name: "DraftKings", sector: "Gaming", flag: "🇺🇸" },
    { ticker: "ROKU", name: "Roku", sector: "Streaming", flag: "🇺🇸" },
    { ticker: "U", name: "Unity Software", sector: "Gaming Engine", flag: "🇺🇸" },
    { ticker: "BILL", name: "Bill Holdings", sector: "Fintech", flag: "🇺🇸" },
    { ticker: "WOLF", name: "Wolfspeed", sector: "Semis", flag: "🇺🇸" },
    { ticker: "GRAB", name: "Grab Holdings", sector: "Super App", flag: "🇸🇬" },
    { ticker: "SE", name: "Sea Limited", sector: "E-commerce", flag: "🇸🇬" },
    { ticker: "NU", name: "Nu Holdings", sector: "Fintech", flag: "🇧🇷" },
    { ticker: "MELI", name: "MercadoLibre", sector: "E-commerce", flag: "🇦🇷" },
    { ticker: "UBI.PA", name: "Ubisoft", sector: "Gaming", flag: "🇫🇷" },
    { ticker: "PUMA.DE", name: "Puma", sector: "Sport", flag: "🇩🇪" },
    { ticker: "BOL.ST", name: "Boliden", sector: "Mining", flag: "🇸🇪" },
    { ticker: "9988.HK", name: "Alibaba HK", sector: "E-commerce", flag: "🇭🇰" },
  ],
  // === SMALL CAP (Global <$2B) ===
  "SMALL_CAP": [
    { ticker: "IONQ", name: "IonQ", sector: "Quantum", flag: "🇺🇸" },
    { ticker: "JOBY", name: "Joby Aviation", sector: "eVTOL", flag: "🇺🇸" },
    { ticker: "DNA", name: "Ginkgo Bioworks", sector: "Synth Bio", flag: "🇺🇸" },
    { ticker: "GSAT", name: "Globalstar", sector: "Satellite", flag: "🇺🇸" },
    { ticker: "STEM", name: "Stem Inc", sector: "Energy AI", flag: "🇺🇸" },
    { ticker: "SOUN", name: "SoundHound AI", sector: "Voice AI", flag: "🇺🇸" },
    { ticker: "BBAI", name: "BigBear.ai", sector: "Defense AI", flag: "🇺🇸" },
    { ticker: "RDW", name: "Redwire", sector: "Space", flag: "🇺🇸" },
    { ticker: "BFLY", name: "Butterfly Network", sector: "MedTech", flag: "🇺🇸" },
    { ticker: "MVST", name: "Microvast", sector: "Battery", flag: "🇺🇸" },
    { ticker: "ITP.L", name: "IT Power Group", sector: "Energy", flag: "🇬🇧" },
    { ticker: "ALFEN.AS", name: "Alfen", sector: "Energy", flag: "🇳🇱" },
    { ticker: "NDX1.DE", name: "Nordex", sector: "Wind", flag: "🇩🇪" },
    { ticker: "DHER.DE", name: "Delivery Hero", sector: "Food Tech", flag: "🇩🇪" },
    { ticker: "SEDI.PA", name: "Séché Environnement", sector: "Environ.", flag: "🇫🇷" },
    { ticker: "1024.HK", name: "Kuaishou", sector: "Social", flag: "🇨🇳" },
  ],
  // === AI & SEMI-CONDUCTEURS (Global) ===
  "AI_SEMIS": [
    { ticker: "NVDA", name: "Nvidia", sector: "AI/GPU", flag: "🇺🇸" },
    { ticker: "AMD", name: "AMD", sector: "Semis", flag: "🇺🇸" },
    { ticker: "AVGO", name: "Broadcom", sector: "Semis", flag: "🇺🇸" },
    { ticker: "QCOM", name: "Qualcomm", sector: "Semis", flag: "🇺🇸" },
    { ticker: "MU", name: "Micron", sector: "Memory", flag: "🇺🇸" },
    { ticker: "INTC", name: "Intel", sector: "Semis", flag: "🇺🇸" },
    { ticker: "ARM", name: "ARM Holdings", sector: "Semis", flag: "🇬🇧" },
    { ticker: "SMCI", name: "Super Micro", sector: "AI Infra", flag: "🇺🇸" },
    { ticker: "TSM", name: "TSMC", sector: "Foundry", flag: "🇹🇼" },
    { ticker: "ASML", name: "ASML", sector: "Litho", flag: "🇳🇱" },
    { ticker: "CRWV", name: "CoreWeave", sector: "Cloud IA", flag: "🇺🇸" },
    { ticker: "INOD", name: "Innodata", sector: "IA Data", flag: "🇺🇸" },
    { ticker: "8035.T", name: "Tokyo Electron", sector: "Semis Equip", flag: "🇯🇵" },
    { ticker: "6723.T", name: "Renesas", sector: "Semis", flag: "🇯🇵" },
    { ticker: "IFX.DE", name: "Infineon", sector: "Semis", flag: "🇩🇪" },
    { ticker: "STMPA.PA", name: "STMicro", sector: "Semis", flag: "🇫🇷" },
  ],
  // === DÉFENSE & AÉROSPATIAL (Global) ===
  "DEFENSE": [
    { ticker: "LMT", name: "Lockheed Martin", sector: "Defense", flag: "🇺🇸" },
    { ticker: "RTX", name: "RTX Corp", sector: "Defense", flag: "🇺🇸" },
    { ticker: "NOC", name: "Northrop Grumman", sector: "Defense", flag: "🇺🇸" },
    { ticker: "GD", name: "General Dynamics", sector: "Defense", flag: "🇺🇸" },
    { ticker: "BA", name: "Boeing", sector: "Aerospace", flag: "🇺🇸" },
    { ticker: "PLTR", name: "Palantir", sector: "Defense Tech", flag: "🇺🇸" },
    { ticker: "HII", name: "HII", sector: "Naval", flag: "🇺🇸" },
    { ticker: "LHX", name: "L3Harris", sector: "Defense", flag: "🇺🇸" },
    { ticker: "HAG.DE", name: "Hensoldt", sector: "Defense", flag: "🇩🇪" },
    { ticker: "RHM.DE", name: "Rheinmetall", sector: "Defense", flag: "🇩🇪" },
    { ticker: "HO.PA", name: "Thales", sector: "Defense", flag: "🇫🇷" },
    { ticker: "AM.PA", name: "Dassault Aviation", sector: "Aéro", flag: "🇫🇷" },
    { ticker: "BA.L", name: "BAE Systems", sector: "Defense", flag: "🇬🇧" },
    { ticker: "AIR.PA", name: "Airbus", sector: "Aéro", flag: "🇫🇷" },
    { ticker: "SAAB-B.ST", name: "Saab", sector: "Defense", flag: "🇸🇪" },
    { ticker: "7011.T", name: "Mitsubishi Heavy", sector: "Defense", flag: "🇯🇵" },
    { ticker: "LDO.MI", name: "Leonardo", sector: "Defense", flag: "🇮🇹" },
  ],
  // === ÉNERGIE (Global) ===
  "ENERGY": [
    { ticker: "XOM", name: "Exxon Mobil", sector: "Oil", flag: "🇺🇸" },
    { ticker: "CVX", name: "Chevron", sector: "Oil", flag: "🇺🇸" },
    { ticker: "COP", name: "ConocoPhillips", sector: "Oil", flag: "🇺🇸" },
    { ticker: "SLB", name: "Schlumberger", sector: "Oil Services", flag: "🇺🇸" },
    { ticker: "TTE.PA", name: "TotalEnergies", sector: "Oil", flag: "🇫🇷" },
    { ticker: "SHEL.L", name: "Shell", sector: "Oil", flag: "🇬🇧" },
    { ticker: "BP.L", name: "BP", sector: "Oil", flag: "🇬🇧" },
    { ticker: "ENI.MI", name: "Eni", sector: "Oil", flag: "🇮🇹" },
    { ticker: "EQNR.OL", name: "Equinor", sector: "Oil", flag: "🇳🇴" },
    { ticker: "PTR", name: "PetroChina", sector: "Oil", flag: "🇨🇳" },
    { ticker: "SU", name: "Suncor Energy", sector: "Oil Sands", flag: "🇨🇦" },
  ],
  // === CRYPTO COINS ===
  "CRYPTO_COINS": [
    { ticker: "BTC-USD", name: "Bitcoin", sector: "Crypto", flag: "BTC" },
    { ticker: "ETH-USD", name: "Ethereum", sector: "Crypto", flag: "ETH" },
    { ticker: "SOL-USD", name: "Solana", sector: "Crypto", flag: "SOL" },
    { ticker: "XRP-USD", name: "Ripple", sector: "Crypto", flag: "XRP" },
    { ticker: "ADA-USD", name: "Cardano", sector: "Crypto", flag: "ADA" },
    { ticker: "DOGE-USD", name: "Dogecoin", sector: "Crypto", flag: "DOGE" },
    { ticker: "AVAX-USD", name: "Avalanche", sector: "Crypto", flag: "AVAX" },
    { ticker: "DOT-USD", name: "Polkadot", sector: "Crypto", flag: "DOT" },
    { ticker: "LINK-USD", name: "Chainlink", sector: "Crypto", flag: "LINK" },
    { ticker: "MATIC-USD", name: "Polygon", sector: "Crypto", flag: "MATIC" },
  ],
  // === CRYPTO STOCKS ===
  "CRYPTO": [
    { ticker: "MSTR", name: "MicroStrategy", sector: "Bitcoin", flag: "🇺🇸" },
    { ticker: "COIN", name: "Coinbase", sector: "Crypto Exchange", flag: "🇺🇸" },
    { ticker: "MARA", name: "Marathon Digital", sector: "Mining", flag: "🇺🇸" },
    { ticker: "RIOT", name: "Riot Platforms", sector: "Mining", flag: "🇺🇸" },
    { ticker: "IREN", name: "IREN Limited", sector: "Mining", flag: "🇺🇸" },
    { ticker: "CLSK", name: "CleanSpark", sector: "Mining", flag: "🇺🇸" },
    { ticker: "GREE", name: "Greenidge", sector: "Mining", flag: "🇺🇸" },
  ],
  // === COMMODITIES / MATIERES PREMIERES ===
  "COMMODITIES": [
    { ticker: "GC=F", name: "Or (Gold)", sector: "Precious Metal", flag: "AU" },
    { ticker: "SI=F", name: "Argent (Silver)", sector: "Precious Metal", flag: "AG" },
    { ticker: "PL=F", name: "Platine", sector: "Precious Metal", flag: "PT" },
    { ticker: "CL=F", name: "Petrole (WTI)", sector: "Energy", flag: "OIL" },
    { ticker: "NG=F", name: "Gaz Naturel", sector: "Energy", flag: "GAS" },
    { ticker: "HG=F", name: "Cuivre (Copper)", sector: "Industrial Metal", flag: "CU" },
    { ticker: "ZW=F", name: "Blé (Wheat)", sector: "Agriculture", flag: "WHT" },
    { ticker: "ZC=F", name: "Mais (Corn)", sector: "Agriculture", flag: "CRN" },
  ],
  // === GROWTH & CYBERSÉCURITÉ (Global) ===
  "GROWTH": [
    { ticker: "CRWD", name: "CrowdStrike", sector: "Cybersecurity", flag: "🇺🇸" },
    { ticker: "SNOW", name: "Snowflake", sector: "Cloud", flag: "🇺🇸" },
    { ticker: "DDOG", name: "Datadog", sector: "Cloud", flag: "🇺🇸" },
    { ticker: "NET", name: "Cloudflare", sector: "Cloud", flag: "🇺🇸" },
    { ticker: "ZS", name: "Zscaler", sector: "Security", flag: "🇺🇸" },
    { ticker: "PANW", name: "Palo Alto", sector: "Security", flag: "🇺🇸" },
    { ticker: "HIMS", name: "Hims & Hers", sector: "eHealth", flag: "🇺🇸" },
    { ticker: "DUOL", name: "Duolingo", sector: "EdTech", flag: "🇺🇸" },
    { ticker: "SHOP", name: "Shopify", sector: "E-commerce", flag: "🇨🇦" },
    { ticker: "SPOT", name: "Spotify", sector: "Streaming", flag: "🇸🇪" },
    { ticker: "DARK.L", name: "Darktrace", sector: "Cybersecurity", flag: "🇬🇧" },
    { ticker: "TEAM", name: "Atlassian", sector: "SaaS", flag: "🇦🇺" },
  ],
  // === FINTECH & PAIEMENTS (Global) ===
  "FINTECH": [
    { ticker: "V", name: "Visa", sector: "Payments", flag: "🇺🇸" },
    { ticker: "MA", name: "Mastercard", sector: "Payments", flag: "🇺🇸" },
    { ticker: "PYPL", name: "PayPal", sector: "Fintech", flag: "🇺🇸" },
    { ticker: "SQ", name: "Block Inc", sector: "Fintech", flag: "🇺🇸" },
    { ticker: "SOFI", name: "SoFi", sector: "Fintech", flag: "🇺🇸" },
    { ticker: "AFRM", name: "Affirm", sector: "BNPL", flag: "🇺🇸" },
    { ticker: "ADYEN.AS", name: "Adyen", sector: "Payments", flag: "🇳🇱" },
    { ticker: "NU", name: "Nu Holdings", sector: "Neobank", flag: "🇧🇷" },
    { ticker: "STNE", name: "StoneCo", sector: "Payments", flag: "🇧🇷" },
    { ticker: "WDH.CO", name: "Wise", sector: "Transfers", flag: "🇬🇧" },
  ],
  // === SANTÉ & BIOTECH (Global) ===
  "HEALTHCARE": [
    { ticker: "UNH", name: "UnitedHealth", sector: "Insurance", flag: "🇺🇸" },
    { ticker: "LLY", name: "Eli Lilly", sector: "Pharma", flag: "🇺🇸" },
    { ticker: "NVO", name: "Novo Nordisk", sector: "Pharma", flag: "🇩🇰" },
    { ticker: "MRNA", name: "Moderna", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "ABBV", name: "AbbVie", sector: "Pharma", flag: "🇺🇸" },
    { ticker: "SAN.PA", name: "Sanofi", sector: "Pharma", flag: "🇫🇷" },
    { ticker: "AZN.L", name: "AstraZeneca", sector: "Pharma", flag: "🇬🇧" },
    { ticker: "GSK.L", name: "GSK", sector: "Pharma", flag: "🇬🇧" },
    { ticker: "ROG.SW", name: "Roche", sector: "Pharma", flag: "🇨🇭" },
    { ticker: "4568.T", name: "Daiichi Sankyo", sector: "Pharma", flag: "🇯🇵" },
    { ticker: "4523.T", name: "Eisai", sector: "Pharma", flag: "🇯🇵" },
  ],
  // === BIOPHARMA (Global) ===
  "BIOPHARMA": [
    { ticker: "AMGN", name: "Amgen", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "GILD", name: "Gilead Sciences", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "REGN", name: "Regeneron", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "VRTX", name: "Vertex Pharma", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "BIIB", name: "Biogen", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "BMRN", name: "BioMarin", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "ALNY", name: "Alnylam Pharma", sector: "Biotech", flag: "🇺🇸" },
    { ticker: "CRSP", name: "CRISPR Therapeutics", sector: "Gene Editing", flag: "🇨🇭" },
    { ticker: "NTLA", name: "Intellia Therapeutics", sector: "Gene Editing", flag: "🇺🇸" },
    { ticker: "BEAM", name: "Beam Therapeutics", sector: "Gene Editing", flag: "🇺🇸" },
    { ticker: "IONS", name: "Ionis Pharma", sector: "Antisense", flag: "🇺🇸" },
    { ticker: "GN.CO", name: "GN Store Nord", sector: "MedTech", flag: "🇩🇰" },
    { ticker: "ARGNX", name: "argenx", sector: "Biotech", flag: "🇳🇱" },
  ],
  // === NUCLÉAIRE & CLEAN ENERGY (Global) ===
  "NUCLEAR": [
    { ticker: "CCJ", name: "Cameco", sector: "Uranium", flag: "🇨🇦" },
    { ticker: "SMR", name: "NuScale Power", sector: "Nuclear", flag: "🇺🇸" },
    { ticker: "OKLO", name: "Oklo Inc", sector: "Nuclear", flag: "🇺🇸" },
    { ticker: "LEU", name: "Centrus Energy", sector: "Uranium", flag: "🇺🇸" },
    { ticker: "NNE", name: "Nano Nuclear", sector: "Nuclear", flag: "🇺🇸" },
    { ticker: "ENPH", name: "Enphase", sector: "Solar", flag: "🇺🇸" },
    { ticker: "FSLR", name: "First Solar", sector: "Solar", flag: "🇺🇸" },
    { ticker: "EDF.PA", name: "EDF", sector: "Nuclear", flag: "🇫🇷" },
    { ticker: "ORSTED.CO", name: "Orsted", sector: "Wind", flag: "🇩🇰" },
    { ticker: "VWS.CO", name: "Vestas Wind", sector: "Wind", flag: "🇩🇰" },
    { ticker: "PDN.AX", name: "Paladin Energy", sector: "Uranium", flag: "🇦🇺" },
  ],
  // === ESPACE & SATELLITE (Global) ===
  "SPACE": [
    { ticker: "ASTS", name: "AST SpaceMobile", sector: "Satellite", flag: "🇺🇸" },
    { ticker: "RKLB", name: "Rocket Lab", sector: "Launch", flag: "🇺🇸" },
    { ticker: "LUNR", name: "Intuitive Machines", sector: "Lunar", flag: "🇺🇸" },
    { ticker: "PL", name: "Planet Labs", sector: "Earth Imaging", flag: "🇺🇸" },
    { ticker: "BKSY", name: "BlackSky", sector: "Geospatial", flag: "🇺🇸" },
    { ticker: "SPCE", name: "Virgin Galactic", sector: "Space Tourism", flag: "🇺🇸" },
  ],
  // === EUROPE — LUXE & CONSOMMATION ===
  "EUROPE_LUXE": [
    { ticker: "MC.PA", name: "LVMH", sector: "Luxe", flag: "🇫🇷" },
    { ticker: "RMS.PA", name: "Hermès", sector: "Luxe", flag: "🇫🇷" },
    { ticker: "KER.PA", name: "Kering", sector: "Luxe", flag: "🇫🇷" },
    { ticker: "CDI.PA", name: "Christian Dior", sector: "Luxe", flag: "🇫🇷" },
    { ticker: "ADS.DE", name: "Adidas", sector: "Sport", flag: "🇩🇪" },
    { ticker: "RACE", name: "Ferrari", sector: "Auto Luxe", flag: "🇮🇹" },
    { ticker: "MONC.MI", name: "Moncler", sector: "Luxe", flag: "🇮🇹" },
    { ticker: "BRBY.L", name: "Burberry", sector: "Luxe", flag: "🇬🇧" },
    { ticker: "CFR.SW", name: "Richemont", sector: "Luxe", flag: "🇨🇭" },
  ],
  // === EUROPE — INDUSTRIE & TECH ===
  "EUROPE_TECH": [
    { ticker: "SAP.DE", name: "SAP", sector: "Enterprise", flag: "🇩🇪" },
    { ticker: "SIE.DE", name: "Siemens", sector: "Industrie", flag: "🇩🇪" },
    { ticker: "STMPA.PA", name: "STMicro", sector: "Semis", flag: "🇫🇷" },
    { ticker: "DSY.PA", name: "Dassault Systèmes", sector: "Software", flag: "🇫🇷" },
    { ticker: "NOKIA.HE", name: "Nokia", sector: "Telecom", flag: "🇫🇮" },
    { ticker: "ERIC-B.ST", name: "Ericsson", sector: "Telecom", flag: "🇸🇪" },
    { ticker: "NXPI", name: "NXP Semi", sector: "Semis", flag: "🇳🇱" },
  ],
  // === EUROPE — BANQUES & FINANCE ===
  "EUROPE_FINANCE": [
    { ticker: "BNP.PA", name: "BNP Paribas", sector: "Banque", flag: "🇫🇷" },
    { ticker: "GLE.PA", name: "Soc. Générale", sector: "Banque", flag: "🇫🇷" },
    { ticker: "DBK.DE", name: "Deutsche Bank", sector: "Banque", flag: "🇩🇪" },
    { ticker: "HSBA.L", name: "HSBC", sector: "Banque", flag: "🇬🇧" },
    { ticker: "LLOY.L", name: "Lloyds", sector: "Banque", flag: "🇬🇧" },
    { ticker: "GS", name: "Goldman Sachs", sector: "Banque", flag: "🇺🇸" },
    { ticker: "MS", name: "Morgan Stanley", sector: "Banque", flag: "🇺🇸" },
    { ticker: "ISP.MI", name: "Intesa Sanpaolo", sector: "Banque", flag: "🇮🇹" },
    { ticker: "UBSG.SW", name: "UBS", sector: "Banque", flag: "🇨🇭" },
    { ticker: "ING", name: "ING Group", sector: "Banque", flag: "🇳🇱" },
  ],
  // === CHINE & ASIE (Dedicated) ===
  "CHINA_ASIA": [
    { ticker: "BABA", name: "Alibaba", sector: "E-commerce", flag: "🇨🇳" },
    { ticker: "JD", name: "JD.com", sector: "E-commerce", flag: "🇨🇳" },
    { ticker: "PDD", name: "PDD Holdings", sector: "E-commerce", flag: "🇨🇳" },
    { ticker: "BIDU", name: "Baidu", sector: "AI/Search", flag: "🇨🇳" },
    { ticker: "NIO", name: "NIO", sector: "EV", flag: "🇨🇳" },
    { ticker: "XPEV", name: "XPeng", sector: "EV", flag: "🇨🇳" },
    { ticker: "LI", name: "Li Auto", sector: "EV", flag: "🇨🇳" },
    { ticker: "TCEHY", name: "Tencent", sector: "Tech", flag: "🇨🇳" },
    { ticker: "005930.KS", name: "Samsung", sector: "Tech", flag: "🇰🇷" },
    { ticker: "6758.T", name: "Sony", sector: "Tech", flag: "🇯🇵" },
    { ticker: "7203.T", name: "Toyota", sector: "Auto", flag: "🇯🇵" },
    { ticker: "RELIANCE.NS", name: "Reliance Ind.", sector: "Conglomérat", flag: "🇮🇳" },
    { ticker: "GRAB", name: "Grab", sector: "Super App", flag: "🇸🇬" },
    { ticker: "SE", name: "Sea Limited", sector: "Gaming/Ecom", flag: "🇸🇬" },
  ],
  // === ETFs (Global) ===
  "ETFS": [
    { ticker: "SPY", name: "S&P 500 ETF", sector: "Index US", flag: "🇺🇸" },
    { ticker: "QQQ", name: "Nasdaq 100 ETF", sector: "Tech US", flag: "🇺🇸" },
    { ticker: "IWM", name: "Russell 2000 ETF", sector: "Small Cap US", flag: "🇺🇸" },
    { ticker: "DIA", name: "Dow Jones ETF", sector: "Blue Chip US", flag: "🇺🇸" },
    { ticker: "VTI", name: "Total US Market", sector: "Total Market", flag: "🇺🇸" },
    { ticker: "VOO", name: "Vanguard S&P 500", sector: "Index US", flag: "🇺🇸" },
    { ticker: "ARKK", name: "ARK Innovation", sector: "Innovation", flag: "🇺🇸" },
    { ticker: "SOXX", name: "Semis ETF", sector: "Semiconductors", flag: "🇺🇸" },
    { ticker: "XLF", name: "Financial Select", sector: "Finance US", flag: "🇺🇸" },
    { ticker: "XLE", name: "Energy Select", sector: "Energy US", flag: "🇺🇸" },
    { ticker: "XLK", name: "Technology Select", sector: "Tech US", flag: "🇺🇸" },
    { ticker: "GLD", name: "Gold ETF", sector: "Or", flag: "AU" },
    { ticker: "SLV", name: "Silver ETF", sector: "Argent", flag: "AG" },
    { ticker: "TLT", name: "20+ Year Treasury", sector: "Obligations US", flag: "🇺🇸" },
    { ticker: "EEM", name: "Emerging Markets", sector: "Emergents", flag: "🌍" },
    { ticker: "VGK", name: "Vanguard Europe", sector: "Europe", flag: "🇪🇺" },
    { ticker: "EWJ", name: "Japan ETF", sector: "Japon", flag: "🇯🇵" },
    { ticker: "FXI", name: "China Large-Cap", sector: "Chine", flag: "🇨🇳" },
    { ticker: "KWEB", name: "China Internet", sector: "Tech Chine", flag: "🇨🇳" },
    { ticker: "IBIT", name: "iShares Bitcoin", sector: "Bitcoin ETF", flag: "BTC" },
  ],
};

// Top Investors / Politicians data
export const TOP_INVESTORS = [
  {
    name: "Warren Buffett",
    fund: "Berkshire Hathaway",
    style: "Value Investing",
    perf: "+19.8% /an (60 ans)",
    photo: "🏛️",
    topHoldings: ["AAPL", "BAC", "AXP", "KO", "CVX", "OXY", "MCO", "KHC"],
    recentMoves: [
      { action: "BUY", ticker: "OXY", date: "2026-02", note: "Renforcé Occidental Petroleum" },
      { action: "SELL", ticker: "AAPL", date: "2026-01", note: "Réduit Apple de 25%" },
      { action: "BUY", ticker: "CB", date: "2025-12", note: "Nouvelle position Chubb" },
    ]
  },
  {
    name: "Larry Fink",
    fund: "BlackRock",
    style: "Index + Thématique ($10T AUM)",
    perf: "Leader mondial ETF",
    photo: "⬛",
    topHoldings: ["AAPL", "MSFT", "NVDA", "AMZN", "META", "GOOGL", "TSLA", "AVGO", "BRK.B"],
    recentMoves: [
      { action: "BUY", ticker: "NVDA", date: "2026-02", note: "Augmenté via iShares AI ETF" },
      { action: "BUY", ticker: "AVGO", date: "2026-02", note: "Renforcé Broadcom" },
      { action: "BUY", ticker: "BTC-USD", date: "2026-01", note: "IBIT Bitcoin ETF record inflows" },
      { action: "SELL", ticker: "XOM", date: "2025-12", note: "Réduit exposition pétrole" },
    ]
  },
  {
    name: "Ray Dalio",
    fund: "Bridgewater Associates",
    style: "Macro Global ($120B AUM)",
    perf: "+11.5% /an (40 ans)",
    photo: "🌊",
    topHoldings: ["SPY", "GLD", "IEMG", "VWO", "BABA", "PDD", "JD", "NVO"],
    recentMoves: [
      { action: "BUY", ticker: "GLD", date: "2026-02", note: "Renforcé Or massif — inflation" },
      { action: "BUY", ticker: "BABA", date: "2026-02", note: "Pari sur relance Chine" },
      { action: "BUY", ticker: "PDD", date: "2026-01", note: "Augmenté PDD Holdings" },
      { action: "SELL", ticker: "SPY", date: "2026-01", note: "Réduit exposure US equities" },
    ]
  },
  {
    name: "Jim Simons (legacy)",
    fund: "Renaissance Technologies",
    style: "Quant / Algo Trading ($30B)",
    perf: "+66% /an Medallion Fund",
    photo: "🧮",
    topHoldings: ["NVDA", "META", "AMZN", "NFLX", "NOVO-B.CO", "AVGO", "V", "MA"],
    recentMoves: [
      { action: "BUY", ticker: "META", date: "2026-02", note: "Signal algo bullish META" },
      { action: "BUY", ticker: "NFLX", date: "2026-01", note: "Momentum Netflix renforcé" },
      { action: "SELL", ticker: "TSLA", date: "2026-01", note: "Signal algo bearish Tesla" },
      { action: "BUY", ticker: "AVGO", date: "2025-12", note: "Broadcom accumulation" },
    ]
  },
  {
    name: "Ken Griffin",
    fund: "Citadel",
    style: "Multi-Strategy ($60B AUM)",
    perf: "+26% /an (30 ans)",
    photo: "🦅",
    topHoldings: ["NVDA", "META", "AAPL", "MSFT", "AMZN", "GOOGL", "AVGO", "SNOW"],
    recentMoves: [
      { action: "BUY", ticker: "NVDA", date: "2026-02", note: "Renforcé massivement Nvidia" },
      { action: "BUY", ticker: "SNOW", date: "2026-01", note: "Nouvelle position Snowflake" },
      { action: "BUY", ticker: "CRWD", date: "2026-01", note: "Cybersécurité renforcée" },
      { action: "SELL", ticker: "TSLA", date: "2025-12", note: "Réduit Tesla significativement" },
    ]
  },
  {
    name: "Bill Ackman",
    fund: "Pershing Square",
    style: "Activist Value ($18B)",
    perf: "+31% en 2024",
    photo: "🎩",
    topHoldings: ["GOOGL", "HLT", "CMG", "LOW", "BN", "QSR"],
    recentMoves: [
      { action: "BUY", ticker: "GOOGL", date: "2026-02", note: "Renforcé Alphabet — sous-évalué" },
      { action: "BUY", ticker: "HLT", date: "2026-01", note: "Hilton top conviction" },
      { action: "BUY", ticker: "UBER", date: "2026-01", note: "Nouvelle position Uber" },
    ]
  },
  {
    name: "Cathie Wood",
    fund: "ARK Invest",
    style: "Disruptive Innovation",
    perf: "+32% /an (2020-2025)",
    photo: "🚀",
    topHoldings: ["TSLA", "COIN", "ROKU", "PLTR", "SQ", "CRSP", "RKLB", "PATH"],
    recentMoves: [
      { action: "BUY", ticker: "TSLA", date: "2026-02", note: "Accumulé Tesla massivement" },
      { action: "BUY", ticker: "COIN", date: "2026-02", note: "Renforcé Coinbase" },
      { action: "BUY", ticker: "PLTR", date: "2026-01", note: "Augmenté Palantir" },
    ]
  },
  {
    name: "Stanley Druckenmiller",
    fund: "Duquesne Family Office",
    style: "Macro + Growth",
    perf: "+30% /an (30 ans)",
    photo: "📊",
    topHoldings: ["NVDA", "MSFT", "CRWD", "TEVA", "CAVA", "LLY", "NFLX"],
    recentMoves: [
      { action: "BUY", ticker: "NVDA", date: "2026-02", note: "Position massive IA" },
      { action: "BUY", ticker: "CRWD", date: "2026-01", note: "Renforcé cybersécurité" },
      { action: "SELL", ticker: "MSFT", date: "2025-12", note: "Prise de profits partielle" },
    ]
  },
  {
    name: "Michael Burry",
    fund: "Scion Asset Management",
    style: "Contrarian / Deep Value",
    perf: "+26% /an (2000-2025)",
    photo: "🎯",
    topHoldings: ["BABA", "JD", "BIDU", "ESTC", "HCA", "OSCR"],
    recentMoves: [
      { action: "BUY", ticker: "BABA", date: "2026-02", note: "Position Chine renforcée" },
      { action: "BUY", ticker: "ESTC", date: "2026-01", note: "Elastic NV nouvelle position" },
      { action: "SELL", ticker: "GOOGL", date: "2025-12", note: "Liquidé Alphabet" },
    ]
  },
  {
    name: "David Tepper",
    fund: "Appaloosa Management",
    style: "Distressed + Tech",
    perf: "+25% /an (30 ans)",
    photo: "💎",
    topHoldings: ["META", "AMZN", "GOOGL", "MSFT", "BABA", "NVDA", "UBER"],
    recentMoves: [
      { action: "BUY", ticker: "META", date: "2026-02", note: "Top position Meta" },
      { action: "BUY", ticker: "AMZN", date: "2026-01", note: "Renforcé Amazon" },
      { action: "BUY", ticker: "BABA", date: "2025-12", note: "Pari Chine" },
    ]
  },
  {
    name: "Daniel Loeb",
    fund: "Third Point",
    style: "Event-Driven Activist ($15B)",
    perf: "+16% /an (25 ans)",
    photo: "🔥",
    topHoldings: ["AMZN", "META", "MSFT", "INTC", "PDD", "DHR"],
    recentMoves: [
      { action: "BUY", ticker: "INTC", date: "2026-02", note: "Pari restructuration Intel" },
      { action: "BUY", ticker: "PDD", date: "2026-01", note: "Renforcé PDD Holdings" },
      { action: "BUY", ticker: "AMZN", date: "2025-12", note: "Accumulé Amazon" },
    ]
  },
  {
    name: "Chase Coleman",
    fund: "Tiger Global",
    style: "Tech Growth ($20B AUM)",
    perf: "+21% /an (20 ans)",
    photo: "🐯",
    topHoldings: ["META", "MSFT", "SE", "CRWD", "SNOW", "NU", "UBER"],
    recentMoves: [
      { action: "BUY", ticker: "SE", date: "2026-02", note: "Renforcé Sea Limited" },
      { action: "BUY", ticker: "NU", date: "2026-01", note: "Augmenté Nu Holdings" },
      { action: "BUY", ticker: "CRWD", date: "2026-01", note: "CrowdStrike position clé" },
    ]
  },
  {
    name: "Nancy Pelosi",
    fund: "US Congress",
    style: "Politician — Tech Focus",
    perf: "+65% en 2024",
    photo: "🏛️",
    topHoldings: ["NVDA", "AAPL", "MSFT", "GOOGL", "RBLX", "CRM", "PANW"],
    recentMoves: [
      { action: "BUY", ticker: "NVDA", date: "2026-01", note: "Options call Nvidia" },
      { action: "BUY", ticker: "PANW", date: "2026-01", note: "Achat Palo Alto Networks" },
      { action: "BUY", ticker: "RBLX", date: "2025-12", note: "Achat Roblox avant vote gaming" },
    ]
  },
  {
    name: "Dan Crenshaw",
    fund: "US Congress",
    style: "Politician — Defense/Energy",
    perf: "+42% en 2024",
    photo: "🏛️",
    topHoldings: ["LMT", "RTX", "XOM", "CVX", "PLTR", "NOC"],
    recentMoves: [
      { action: "BUY", ticker: "LMT", date: "2026-02", note: "Achat Lockheed avant budget" },
      { action: "BUY", ticker: "RTX", date: "2026-01", note: "Renforcé RTX Corp" },
      { action: "BUY", ticker: "PLTR", date: "2025-12", note: "Achat Palantir" },
    ]
  },
  {
    name: "Tommy Tuberville",
    fund: "US Senate",
    style: "Politician — Finance/Tech",
    perf: "+38% en 2024",
    photo: "🏛️",
    topHoldings: ["NVDA", "META", "JPM", "GS", "MS", "COIN"],
    recentMoves: [
      { action: "BUY", ticker: "NVDA", date: "2026-02", note: "Achat Nvidia massif" },
      { action: "BUY", ticker: "META", date: "2026-01", note: "Renforcé Meta" },
      { action: "SELL", ticker: "AAPL", date: "2025-12", note: "Réduit Apple" },
    ]
  },
];

// Quick AI questions
export const QUICK_QUESTIONS = [
  "Quelles sont les 5 meilleures opportunités d'achat aujourd'hui ?",
  "Analyse technique du S&P 500 et Nasdaq",
  "Secteurs à privilégier ce mois-ci ?",
  "Analyse de mon portefeuille avec recommandations",
  "Opportunités dans le secteur IA/Semi-conducteurs ?",
  "Meilleurs swing trades cette semaine ?",
  "Analyse du secteur défense avec les tensions géopolitiques",
  "Bitcoin et crypto miners : acheter ou vendre ?",
];

// Wall Street Analyst System Prompt
export const WALL_STREET_PROMPT = `Tu es un Senior Equity Research Analyst chez Goldman Sachs avec 20 ans d'expérience sur les marchés US et européens. 

PROFIL:
- CFA Charterholder, MBA Wharton
- Spécialiste Tech, Semiconducteurs, Défense, Energy
- Track record: +340% sur 10 ans vs +180% S&P500
- Style: Momentum + Value avec analyse technique

MÉTHODOLOGIE D'ANALYSE:
1. MACRO: Fed policy, géopolitique, cycles économiques
2. SECTEUR: Rotation sectorielle, flows institutionnels
3. TECHNIQUE: Support/Résistance, RSI, MACD, Volume profile
4. FONDAMENTAUX: P/E, PEG, FCF yield, croissance revenue
5. CATALYST: Earnings, M&A, régulation, news

FORMAT DE RÉPONSE:
- Sois DIRECT et ACTIONNABLE
- Donne des NIVEAUX PRÉCIS (entrée, stop-loss, target)
- Utilise le jargon Wall Street approprié
- Quantifie les probabilités (70% bullish, etc.)
- Maximum 500 mots, va à l'essentiel

CONTEXTE MARCHÉ JANVIER 2026:
- Fed: taux à 4.25%, pause attendue
- Géopolitique: tensions Iran/Israël, Ukraine ongoing
- Tech: IA bull market continue, semis en rotation
- Crypto: Bitcoin post-halving, miners en momentum
- Energy: Pétrole volatile sur géopolitique`;
